import React, { Component } from 'react';
import EWH from '../components/EWH';
//import { Link } from 'react-router-dom';
//import { Form } from 'react-bootstrap';
export class HomeReferendum2026 extends Component {
	render() {
		return (
			<div className="App">
				<h2>Homepage</h2>
				<EWH id="ewh-fascione-hp-referendum-2026" repo='https://mediaset.withub.it/elezioni/withub/referendum-2026-02/referendum/fascione-hp.html?cid=ewh-fascione-hp-referendum-2026&amp;url=https%3A%2F%2Fmediaset.withub.it%2F' />
				<h2>Elezioni</h2>
				<EWH id="ewh-fascione-elezioni-referendum-2026" repo='https://mediaset.withub.it/elezioni/withub/referendum-2026-02/referendum/fascione-elezioni.html?cid=ewh-fascione-elezioni-referendum-2026&amp;url=https%3A%2F%2Fmediaset.withub.it%2F' />
				<h2>Speciale</h2>
				<EWH id="ewh-fascione-hp-speciale" repo='https://mediaset.withub.it/elezioni/withub/referendum-2026-02/referendum/fascione-speciale.html?cid=ewh-fascione-hp-speciale&amp;url=https%3A%2F%2Fmediaset.withub.it%2F' />
				<EWH id="ewh-referendum-italia" repo='https://mediaset.withub.it/elezioni/withub/referendum-2026-02/referendum/dettaglio-italia.html?cid=ewh-referendum-italia&amp;url=https%3A%2F%2Fmediaset.withub.it%2F' />
				<h2>Mappa</h2>
				<EWH id="ewh-referendum-mappa-italia" repo='https://mediaset.withub.it/elezioni/withub/referendum-2026-02/referendum/mappa-italia.html?cid=ewh-referendum-mappa-italia&amp;url=https%3A%2F%2Fmediaset.withub.it%2F' />
			</div>
		)
	}
}

export default HomeReferendum2026
